//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
import "../no/ugmath.js";
let d=[[[0,"CanCopyAsSketch",1,0],[0,"CopyNonAssociative",1,0],[0,"DestinationFilename",1,0],[0,"InitialCopyLocation",1,0],[0,"IsCut",1,0],[0,"ToClipboard",1,0]],[[[],"GetCopyCutStatus",{R_:{copyCutStatus:''}},0,0],[["numNonExportableObjects"],"GetNonExportableObjects",{R_:{nonExportableObjects:"NXObject[]"}},0,0],[["numObjects"],"GetObjects",{R_:{objects:"NXObject[]"}},0,0],[["objects"],"SetObjects",{},1,0],[[],"ResetInitialCopyLocation",{},0,0]],[]];
SPLM.Gateway.CopyCutBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.CopyCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.CopyCutBuilder.Status = Object.freeze({
    "NoObjectsCopied" : "NoObjectsCopied", "NonExportableObjects" : "NonExportableObjects", "PartExportFailed" : "PartExportFailed", "ErrorDuringCut" : "ErrorDuringCut", "AllObjectsCopied" : "AllObjectsCopied"});

export default SPLM;